export interface IntroCallState {
	attendees: string;
	callTookPlace: boolean;
	clientId: string;
	note: string;

	reportId: string;
	sessionId: string;
}

export const initialIntroCallState: IntroCallState = {
	reportId: '',
	clientId: '',
	sessionId: '',
	attendees: '',
	note: '',
	callTookPlace: false,
};

export enum ACTIONS {
	setState = 'setState',
	setAttendees = 'setAttendees',
	setNote = 'setNote',
	setCallTookPlace = 'setCallTookPlace',
}

export interface ActionProperties {
	payload: any;

	type: ACTIONS;
}

export const introCallReducer = (state: IntroCallState, action: ActionProperties): IntroCallState => {
	const { type, payload } = action;

	switch (type) {
		case ACTIONS.setState:
			return {
				...state,
				...payload,
			};
		case ACTIONS.setAttendees:
			return {
				...state,
				attendees: payload,
			};
		case ACTIONS.setNote:
			return {
				...state,
				note: payload,
			};
		case ACTIONS.setCallTookPlace:
			return {
				...state,
				callTookPlace: payload,
			};
		default:
			return state;
	}
};
